import s from "./index353.js";
import { resolveComponent as e, createBlock as a, createCommentVNode as i, openBlock as r, withCtx as m, createVNode as d } from "vue";
import l from "./index231.js";
function p(n, c, h, _, k, u) {
  const o = e("hydrated-link-list"), t = e("ms-hydration");
  return n.hasLinks ? (r(), a(t, {
    key: 0,
    name: "HydratedLinkList",
    "data-component": n.$options.name
  }, {
    default: m(() => [
      d(o, {
        links: n.links,
        headline: n.headline,
        isInVIM: n.isInVIM,
        hasMaxColumns: n.hasMaxColumns
      }, null, 8, ["links", "headline", "isInVIM", "hasMaxColumns"])
    ]),
    _: 1
  }, 8, ["data-component"])) : i("", !0);
}
const C = /* @__PURE__ */ l(s, [["render", p]]);
export {
  C as default
};
